import { ControlProps } from "@jsonforms/core";
import { withJsonFormsControlProps } from "@jsonforms/react";
import React from "react";
import {
  FormDetailItem,
  FormDetailValue,
  FormDetailWrapper,
} from "../../messageType/contentType/FormContent.style";
import dayjs from "dayjs";
import { HHNConstants } from "@home-health-notify/domain";

const AppointmentPickerViewRenderer = ({ data, label }: ControlProps) => {
  const getVisitTime = () => {
    const visitDate = data.visitDate
      ? dayjs(data.visitDate).format(HHNConstants.DATE_VIEW_FORMAT)
      : "N/A";
    const startTime =
      data.visitStartTime &&
      dayjs(data.visitStartTime).format(HHNConstants.TIME_VIEW_FORMAT);
    const endTime =
      data.visitEndTime &&
      dayjs(data.visitEndTime).format(HHNConstants.TIME_VIEW_FORMAT);

    const visitTime =
      startTime && endTime ? `${startTime} to ${endTime}` : "N/A";
    return {
      visitDate,
      visitTime,
    };
  };
  const { visitDate, visitTime } = getVisitTime();
  return (
    <>
      <FormDetailWrapper data-testid="form-content-item">
        <FormDetailItem>{label} Date :</FormDetailItem>
        <FormDetailValue>{visitDate}</FormDetailValue>
      </FormDetailWrapper>
      <FormDetailWrapper data-testid="form-content-item">
        <FormDetailItem>{label} Time :</FormDetailItem>
        <FormDetailValue>{visitTime}</FormDetailValue>
      </FormDetailWrapper>
    </>
  );
};

export default withJsonFormsControlProps(AppointmentPickerViewRenderer);
